import { useState } from 'react';
import { useParams } from 'react-router';
import Card from '@/components/UI/Card/index.tsx';
import PlusIcon from '@/components/UI/Icons/PlusIcon';
import { useApplicationEvents } from '@/hooks/ReactQueryHooks/useApplicationQuery';
import type { ApplicationPhaseType, IApplicationEvent } from '@/types/ClientApplication';
import DueDiligenceEvent from './DueDiligenceEvent';
import { ApplicationEventFormModal } from './DueDiligenceEventFormModal';

interface IDueDiligenceEventsProps {
  title: string;
  phase: ApplicationPhaseType;
}

const DueDiligenceEvents = ({ title, phase }: IDueDiligenceEventsProps) => {
  const { applicationId } = useParams();

  const [showModal, setShowModal] = useState<boolean>(false);
  const [selectedApplicationEvent, setSelectedApplicationEvent] = useState<IApplicationEvent>();

  const fetchApplicationEvents = useApplicationEvents({
    applicationId: applicationId!,
  });
  const applicationEvents = fetchApplicationEvents?.data?.data?.eventList;

  const handleApplicationEventModal = () => {
    setShowModal((prev) => !prev);
  };

  const handleApplicationEventAdd = () => {
    setSelectedApplicationEvent(undefined);
    handleApplicationEventModal();
  };

  return (
    <Card
      title='Events'
      titleElement={
        <span className='cursor-pointer' onClick={handleApplicationEventAdd}>
          <PlusIcon />
        </span>
      }
    >
      {applicationEvents && applicationEvents?.length > 0 && (
        <div className='p-4 h-80 overflow-y-scroll' id='dueDiligence-events'>
          {applicationEvents?.map((e: IApplicationEvent, index: number) => (
            <DueDiligenceEvent key={e.id || index} event={e} phase={phase} />
          ))}
        </div>
      )}
      {(!applicationEvents || applicationEvents?.length === 0) && (
        <div className='flex flex-col gap-2 justify-center items-center h-1/2'>
          <p className='m-0 text-center'>There are no events added in this due diligence.</p>
        </div>
      )}
      {showModal && (
        <ApplicationEventFormModal
          handleModal={handleApplicationEventModal}
          hookFormConfig={{
            defaultValues: {
              name: '',
              date: '',
              ...selectedApplicationEvent,
            },
          }}
          title={title}
          phase={phase}
        />
      )}
    </Card>
  );
};

export default DueDiligenceEvents;
